import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectAboutsFetchFailedAction = {
	type: 'SUBJECT_ABOUTS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectAboutsFetchFailedAction => ({
	type: 'SUBJECT_ABOUTS_FETCH_FAILED',
	payload,
});
